// src/components/Login/AdminRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Protege rotas exclusivas de admin.
 * Verifica: token presente + modulo === "admin"
 */
const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem("inteagro_token");
  const modulo = localStorage.getItem("modulo");

  if (!token) return <Navigate to="/" />;
  if (modulo !== "admin") return <Navigate to="/redirect" />;

  return <>{children}</>;
};

export default AdminRoute;
